const tokensIT = {
    "view": {
        "title": "Cronologia token",
        "table": {
            "column": {
                "quantity": "Quantita",
                "description": "Descrizione",
                "type": "Tipo",
                "balance": "Saldo",
                "date": "Data",
                "receipt": "Ricevuta"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "button": {
                "view": "Visualizza",
                "export_csv": "Esporta CSV",
                "order_tokens": "Ordina token"
            },
            "label": {
                "not_available": "Non disponibile",
                "credit": "Accredito",
                "debit": "Addebito"
            }
        }
    },
    "order": {
        "title": "Ordina token",
        "form": {
            "label": {
                "quantity": "Quantita"
            },
            "placeholder": {
                "quantity": "Seleziona quantita"
            },
            "help": {
                "quantity": "Numero di token che desideri ordinare."
            },
            "validation": {
                "quantityRequired": "La quantita e obbligatoria"
            },
            "button": {
                "placeOrder": "Effettua ordine"
            },
            "option": {
                "tokensAmount": "{{count}} token"
            }
        },
        "modal": {
            "title": "Procedi al pagamento",
            "orderedPrefix": "Hai ordinato",
            "description": "Se vuoi confermare l'ordine, procedi al pagamento; altrimenti puoi annullare l'ordine.",
            "button": {
                "cancel": "Annulla",
                "checkout": "Paga"
            }
        },
        "message": {
            "error": "Qualcosa e andato storto! Aggiorna la pagina e riprova!"
        }
    },
    "transaction": {
        "success": {
            "title": "Transazione riuscita :)",
            "description": "Hai acquistato correttamente i token che verranno aggiunti a breve al tuo account!"
        },
        "cancel": {
            "title": "Transazione annullata :(",
            "description": "La transazione e stata annullata... Riprova piu tardi!"
        },
        "button": {
            "returnToDashboard": "Torna alla dashboard"
        }
    }
};

export default tokensIT;
